import { parseInboundPayload } from '../../inbound';
import { numberParser } from '../../inboundParsers';
import { trimBraces } from '../../inboundUtils';
export function chipsBetPerPlayerParser(str) {
    const inboundParts = trimBraces(str).split(',');
    return parseInboundPayload(inboundParts, chipsBetPerPlayerPartDefinitions);
}
const chipsBetPerPlayerPartDefinitions = [
    { name: 'playerId', parser: numberParser },
    { name: 'numChips', parser: numberParser },
    { name: 'numChipsThisPhase', parser: numberParser }
];
